import React from "react";

import { LuX } from "react-icons/lu";

interface ImageDialogProps {
  imageUrl: string;
  onClose: () => void;
  isOpen: boolean;
}

const ImageDialog: React.FC<ImageDialogProps> = ({
  imageUrl,
  onClose,
  isOpen,
}) => {
  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center ${
        isOpen ? "flex" : "hidden"
      }`}
      role="dialog"
      aria-modal="true"
    >
      <button
        type="button"
        className="absolute inset-0 z-0 cursor-default border-0 bg-black/60 p-0"
        aria-label="Close dialog"
        onClick={onClose}
      />
      <div className="pointer-events-none relative z-10 flex max-h-[90vh] max-w-[90vw] items-center justify-center p-4">
        <div className="pointer-events-auto relative max-h-full max-w-full">
          <button
            className="absolute -right-2 -top-2 z-20 rounded-full bg-black/50 p-2 text-white hover:bg-black/70 focus:outline-none"
            type="button"
            onClick={onClose}
            aria-label="Close"
          >
            <LuX className="h-6 w-6" />
          </button>
          <img
            src={imageUrl}
            alt="Enlarged attachment"
            className="max-h-[90vh] max-w-[90vw] rounded-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default ImageDialog;
